(function () {
    "use strict";


    // @ngInject
    function NetworkManagerCtor($q, APIService, Routes, ModelFactory, RepositoryService, UsersManager) {
        this.constructor.$super.call(this, APIService,ModelFactory, $q);
        this.Routes = Routes;
        this.UsersManager = UsersManager;
        this.RepositoryService = RepositoryService;
        this.networkUsers =  this.ModelFactory.newNetworkUsersCollection();
        this.networkProjects =  this.ModelFactory.newNetworkProjectsCollection();
        this.$q = $q;
        this.UsersManager = UsersManager;

        this._connectionSuggestionViewList = [];
        this._connectionSuggestionViewTimer = null;
    }

    Services.NetworkManager = Class(Services.BaseModelManager, {

        constructor: NetworkManagerCtor,

        updateNetworkUserProfile: function updateNetworkUserProfile(user, data) {
            var url = this.Routes.v2_update_network_user_path(user._id);
            var promise = this.apiUpdate(url, data, user, true);
            promise.then(
                function success(resp) {
                    user.mixinFrom(resp.data.user, null, true, true);
                }
            );
            return promise;
        },

        getNetworkCurrUser: function getNetworkCurrUser(refresh) {
            var user = this.UsersManager.getCurrUser();
            refresh = refresh === true; // default false
            if (refresh || angular.isUndefined(user.network) || !user.network._id) {
                this.user = this.getNetworkUser(user._id);
                this.user.on('success', function () {
                    user.mixinFrom(this.user, undefined, true);
                    this.UsersManager._setCurrUser(user);
                    user.trigger('network_user_success');
                }.bind(this));
            }
            return user;
        },

        getNetworkUser: function getNetworkUser(userId, refresh) {
            refresh = refresh !== false; // default true
            var user = this.RepositoryService.cacheGet("UserModel", userId);
            if (!user) {
                user = this.ModelFactory.newUserModel();
                user._id = userId;
                this.RepositoryService.cachePut(user);
            } else if (!refresh && user.network) {
                // no need to fetch, guess we need only basic stuff
                return user;
            }

            if (!this.isModelTimedOut(user, refresh === true) && user.network) {
                return user;
            }

            var url = this.Routes.v2_get_network_user_path(userId);
            var data = null;
            this.apiFetch(url, data, user, true);

            return user;
        },


        // getNetworkUseroooolllls: function getNetworkUsers(userId) {
        //     var user = this.ModelFactory.newUserModel();
        //     var url = this.Routes.v2_get_network_user_path(userId);
        //     return this.apiFetch(url, null, user, true);
        // },

        getNetworkUsersMasterCollection: function getNetworkUsersMasterCollection() {
            return this.ModelFactory.getNetworkUsersMasterCollection();
        },

        getNetworkUsersCollection: function getNetworkUsersCollection() {

            if (!this.networkUsers){
                this.networkUsers = this.ModelFactory.newNetworkUsersCollection();
            }

            return this.networkUsers;
        },


        listNetworkUsers: function listNetworkUsers(page, vendorTypes, state, city, term, numResults,networkUsersCollection) {
            var networkUsers = networkUsersCollection;


            var data = {
                page: page,
                state: state,
                city: city,
                term: term
            };
            if (vendorTypes && angular.isArray(vendorTypes)) {
                data['vendor_types'] = vendorTypes.join();
            }
            if (numResults && numResults > 0) {
                data['num_results'] = numResults;
            }

            var url = this.Routes.v2_list_network_users_path();
            // return this.apiFetch(url, data);
            // this.apiFetchCollection(url, data, networkUsers, true, null, true);

            // if (useMasterCollection) {
            //     return this.apiFetchCollection(url, data, networkUsers, true, null, false, true, true).then(function (res) {
            //         this.networkUsers.total_count =res.total_count;
            //
            //     }.bind(this));;
            //     // return networkUsers;
            // } else {

                // return this.apiFetch(url, data);
                return this.apiFetchCollection(url, data, networkUsers, true,null,false,false,false);
            // return networkUsers;
            // }


        },

        getConnections: function getConnections(connections,user_id, page, show_my_requests) {

            var pageToFetch = page ? page : 1;
            var showMyRequests = show_my_requests || false;
            var data = {"page": pageToFetch};
            if (showMyRequests){
                data['my_requests'] = showMyRequests;
            }

            var url = this.Routes.v2_get_connections_path(user_id);
            return this.apiFetchCollection(url, data, connections, true,null,false,false,true);
        },

        getConnectionSuggestions: function listConnectionSuggestions(suggestionsCollection, minLimit, maxLimit, shouldSkipUserIds) {

            if (!minLimit) {
                minLimit = 15;
            }
            if (!maxLimit) {
                maxLimit = 30;
            }

            var data = {
                min_limit: minLimit,
                max_limit: maxLimit
            };

            if (shouldSkipUserIds && suggestionsCollection.length > 0) {
                data.skip_user_ids = suggestionsCollection.map(function (user){
                   return user._id;
                }).join(",");
            }

            var newCollection = this.ModelFactory.newNetworkUsersCollection();
            var url = this.Routes.v2_suggested_connections_path();
            this.apiFetchCollection(url, data, newCollection, true);
            return newCollection;
        },

        connectionSuggestionViewBulk: function connectionSuggestionViewBulk(userId) {
            this._connectionSuggestionViewList.push(userId);
            if (!this._connectionSuggestionViewTimer) {
                this._connectionSuggestionViewTimer = setTimeout(function connectionSuggestionViewCbk() {
                    var params = {
                        action_type: 'view'
                    };
                    this.updateUserConnectionSuggestionsBulk(this._connectionSuggestionViewList, params);
                    this._connectionSuggestionViewList = [];
                    this._connectionSuggestionViewTimer = null;
                }.bind(this), 1000);
            }
        },

        connectionSuggestionView: function connectionSuggestionView(userId) {
            var params = {
                action_type: 'view'
            };
            return this.updateConnectionSuggestion(userId, params);
        },

        connectionSuggestionHide: function connectionSuggestionHide(userId) {
            var params = {
                action_type: 'hide'
            };
            return this.updateConnectionSuggestion(userId, params);
        },

        connectionSuggestionConvert: function connectionSuggestionConvert(userId, conversionSource, sourceDetails) {
            conversionSource = conversionSource || 'web_app';
            var params = {
                action_type: 'conversion',
                conversion_source: conversionSource
            };
            if (sourceDetails) {
                params.source_details = sourceDetails;
            }
            return this.updateConnectionSuggestion(userId, params);
        },

        updateConnectionSuggestion: function updateConnectionSuggestion(userId, params) {
            var url = this.Routes.v2_update_user_connection_suggestion_path(userId);
            return this.apiUpdate(url, params, null);
        },

        updateUserConnectionSuggestionsBulk: function updateUserConnectionSuggestionsBulk(userIds, params) {
            params = params || {};
            params.user_ids = userIds;
            var url = this.Routes.v2_update_user_connection_suggestions_bulk_path();
            return this.apiUpdate(url, params, null);
        },

        createConnectionRequest: function createConnectionRequest(userToConnectId) {

            var data = {"user_id": userToConnectId};

            var connection = this.ModelFactory.newNetworkUserModel();
            var url = this.Routes.v2_create_connection_path();
            this.apiCreate(url, data, connection, true);
            return connection;
        },

        updateConnection: function updateConnection(userConnection, connection_action) {

            var data = {"connection_action": connection_action};

            var url = this.Routes.v2_update_connection_path(userConnection.network.connection_data.connection_id);
            return this.apiUpdate(url, data, userConnection, true);
        },

        getProjects: function getProjects(userId) {
            var projects = this.ModelFactory.newNetworkProjectsCollection();
            var url = this.Routes.v2_list_network_user_projects_path(userId);
            this.apiFetchCollection(url, null, projects, true);
            return projects;
        },

        getFeaturedProjects: function getFeaturedProjects(connectionsFilter, vendorTypesFilter, locationFilter, page, numResults, projectsCollection) {
            var networkProjects = projectsCollection;

            var data = {
                connected_only: connectionsFilter,
                vendor_types: vendorTypesFilter.toString(),
                coordinates:locationFilter.toString(),
                page: page
            };

            if (numResults && numResults > 0) {
                data['num_results'] = numResults;
            }

            var url = this.Routes.v2_list_network_projects_path();
            return this.apiFetchCollection(url, data, networkProjects, true,null,false,false,false);

        },

        // getUserFeed: function getUserFeed(user,feed, lastFeedId, pinnedObjectId, myOpportunitiesOnly, allOpportunities, allProjects) {
        //
        //     var data ={
        //         my_opportunities_only: myOpportunitiesOnly,
        //         all_opportunities: allOpportunities,
        //         all_projects: allProjects
        //     };
        //
        //     if (lastFeedId) {
        //         data.last_feed_id = lastFeedId;
        //     }
        //     if(pinnedObjectId){
        //         data.pinned_object_id = pinnedObjectId;
        //     }
        //
        //     var url = this.Routes.v2_get_network_user_feed_path(user._id);
        //     return this.apiFetchCollection(url, data, feed.feed_items, true, null, false, false, true); // server side pagination
        // },

        getUserProjects: function getUserProjects(user, coordinates, projects, lastCreatedAt, pinnedObjectId, status) {

            var data = {};
            
            var longitude = (coordinates && coordinates.length && !!coordinates[0]) ? coordinates[0] : false;
            var latitude = (coordinates && coordinates.length && !!coordinates[1]) ? coordinates[1] : false;

            if (longitude && latitude) {
                data.lng = longitude;
                data.lat = latitude;
            }

            if (status) {
                data.status = status;
            }
 
            if (lastCreatedAt) {
                data.last_created_at = lastCreatedAt;
            }

            if (pinnedObjectId) {
                data.pinned_object_id = pinnedObjectId;
            }

            var url = this.Routes.v2_list_network_projects_path();
            return this.apiFetchCollection(url, data, projects, true, null, false, false, true); // server side pagination
        },


        getUserOpportunities: function getUserOpportunities(user, coordinates, opportunities, lastCreatedAt, pinnedObjectId, myOpportunitiesOnly, allOpportunities, isServerSidePaging) {

            isServerSidePaging = (isServerSidePaging === undefined) ? true : isServerSidePaging;

            var data = {
                my_opportunities_only: myOpportunitiesOnly,
                all_opportunities: allOpportunities
            };

            var longitude = (coordinates && coordinates.length && !!coordinates[0]) ? coordinates[0] : false;
            var latitude = (coordinates && coordinates.length && !!coordinates[1]) ? coordinates[1] : false;

            if (longitude && latitude) {
                data.lng = longitude;
                data.lat = latitude;
            }

            if (lastCreatedAt) {
                data.last_created_at = lastCreatedAt;
            }

            if (pinnedObjectId) {
                data.pinned_object_id = pinnedObjectId;
            }

            var url = this.Routes.v2_get_network_user_opportunities_path(user._id);
            return this.apiFetchCollection(url, data, opportunities, true, null, false, false, isServerSidePaging); // server side pagination
        },

        getOpportunitiesByIds: function getOpportunitiesByIds(user, opportunities, opportunitiesIds) {

            var data ={};
            if (opportunitiesIds) {
                data.opportunity_ids = opportunitiesIds;
            }

            var url = this.Routes.v2_get_opportunities_path();
            return this.apiFetchCollection(url, data, opportunities, true, null, false, false, true); // server side pagination
        },

        getOpportunitiesModerationQueue: function getOpportunitiesModerationQueue(opportunities) {

            var data ={moderation_queue: true};

            var url = this.Routes.v2_get_opportunities_path();
            return this.apiFetchCollection(url, data, opportunities, true, null, false, false, true); // server side pagination
        },

        getNetworkProjectsCollection: function getNetworkProjectsCollection() {

            if (!this.networkProjects){
                this.networkProjects = this.ModelFactory.newNetworkProjectsCollection();
            }

            return this.networkProjects;
        },

        getProject: function getProject(projectId) {
            var project = this.ModelFactory.newNetworkProjectModel();
            var url = this.Routes.v2_get_network_project_path(projectId);
            this.apiFetch(url, null, project, true);
            return project;
        },

        updateNetworkProject: function updateNetworkProject(project, data) {
            var url = this.Routes.v2_update_network_project_path(project._id);
            return this.apiUpdate(url, data, project, true);
        },

        updateNetworkProjectMembers: function updateNetworkProjectMembers(project, member_ids) {
            var url = this.Routes.v2_update_network_project_members_path(project._id);
            var data = {
                member_ids: member_ids
            };
            return this.apiUpdate(url, data, project, true);
        },

        createNetworkProject: function createNetworkProject(data) {
            var project = this.ModelFactory.newNetworkProjectModel();
            var url = this.Routes.v2_create_network_project_path();
            this.apiCreate(url, data, project, true);
            return project;
        },

        setProjectCoverImage: function setDefaultCoverImage(project, image_id) {
            var data = {
                image_id: image_id
            };

            var url = this.Routes.v2_update_network_project_cover_photo_path(project._id);
            return this.apiUpdate(url, data, project, true);
        },

        addNetworkUserFromProject: function addNetworkUserFromProject(user, project) {
            var data = user.dataOnly();
            data['source'] = 'network_project';
            if (project._id) {
                data['project_id'] = project._id;
            }
            var url = this.Routes.v2_add_network_user_from_project_path();
            return this.apiCreate(url, data);
        },

        inviteUserAsNetworkConnection: function inviteUserAsNetworkConnection(user) {
            var data = user.dataOnly();
            data['source'] = 'network_invite';
            data['connect_user'] = true;
            var url = this.Routes.v2_add_network_user_from_project_path();
            return this.apiCreate(url, data);
        },

        deleteAsset: function deleteAsset(project, assetId) {
            var url = this.Routes.v2_network_project_remove_asset_path(project._id, assetId);
            return this.apiDelete(url, null, project, true);
        },

        addImageToGallery: function addImageToGallery(project, s3Response) {
            var assetType = 'project_portfolio_image'; //currently we handle only gallery images upload
            var url = this.Routes.v2_network_project_save_asset_path(project._id, assetType);
            return this.apiCreate(url, s3Response, project, true);
        },

        getNetworkUserByGuid: function getNetworkUserByGuid(userId, guid, userModel) {
            var user = userModel || this.UsersManager.newUser();
            var data = {
                id: userId,
                reset_password_guid: guid,
            };
            var url = this.Routes.v2_network_user_by_reset_guid_path();
            return this.apiFetch(url, data, user, true);
        },

        getCurrentNetworkOnboardingStep: function getCurrentNetworkOnboardingStep() {
            var currUser = this.UsersManager.getCurrUser();
            var url = this.Routes.v2_get_network_onboarding_step_path(currUser._id);
            return this.apiFetch(url, null, currUser, true);
        },

        setNetworkOnboardingStepComplete: function setNetworkOnboardingStepComplete(step) {
            var currUser = this.UsersManager.getCurrUser();
            var url = this.Routes.v2_set_network_onboarding_step_complete_path(currUser._id, step);
            return this.apiUpdate(url, null, currUser, true);
        },

        setUnlockHoneybook: function setUnlockHoneybook(user) {
            var url = this.Routes.v2_set_network_unlock_path(user._id);
            return this.apiUpdate(url, null, user, true);
        },

        deleteNetworkProject: function deleteNetworkProject(user,projectId) {
            var url = this.Routes.v2_delete_network_project_path(projectId);
            return this.apiDelete(url, null, user, true);
        },

        setProjectLikeStatus: function setProjectLikeStatus(project, status){
            var data = {status: status};
            var url = this.Routes.v2_set_network_project_like_status_path(project._id);
            return this.apiUpdate(url, data, project, true);
        },

        setUserProfileViewed: function setUserProfileViewed(user) {
            var url = this.Routes.v2_user_was_viewed_path(user._id);
            return this.apiCreate(url, null, user, false);
        },

        addNewComment: function addNewComment(networkObject, networkObjectType, comment){
            var data = {comment_body: comment};
            var url;
            switch(networkObjectType){
                case "network_project":
                    url = this.Routes.v2_add_network_project_comment_path(networkObject._id);
                    break;
                case "network_referral":
                    url = this.Routes.v2_add_network_referral_comment_path(networkObject._id);
                    break;
                default:
                    return;
            }
            return this.apiCreate(url, data, networkObject, true);
        },

        saveNetworkReferral: function saveNetworkReferral(data) {
            var newNetworkReferral = this.ModelFactory.newNetworkReferralModel();
            var url = this.Routes.v2_create_network_referral_path();
            this.apiCreate(url, data, newNetworkReferral, true);
            return newNetworkReferral;
        },

        updateNetworkReferral: function updateNetworkReferral(referral, data) {
            var url = this.Routes.v2_update_network_referral_path(referral._id);
            return this.apiUpdate(url, data, referral, true);
        },

        moderateNetworkReferral: function moderateNetworkReferral(referral, action) {
            var data = {moderation_action: action};
            var url = this.Routes.v2_moderate_network_referral_path(referral._id);
            return this.apiCreate(url, data, referral, true);
        },

        generateOpportunityConciergeEmail: function generateOpportunityConciergeEmail(referral) {

            var url = this.Routes.v2_generate_opportunity_concierge_email_path(referral._id);
            return this.apiFetch(url, null, null, false);
        },

        saveNetworkEmailUnsubscribes: function saveNetworkEmailUnsubscribes(user, data) {
            var url = this.Routes.v2_save_network_email_unsubscribes_path();
            return this.apiUpdate(url, data, user, true);
        },

        getRtsChapters: function getRtsChapters(filter) {
            var url = this.Routes.v2_search_rts_chapters_path();

            var data = {};
            if (filter) {
                data.query = filter;
            }

            return this.apiFetch(url, data);
        },

        setOpportunityLikeStatus: function setOpportunityLikeStatus(opp, status) {
            var url = this.Routes.v2_set_opportunity_like_status_path(opp._id);
            var data = {status: status};
            return this.apiUpdate(url, data, opp, true);
        },

        likeOpportunity: function likeOpportunity(opp) {
            return this.setOpportunityLikeStatus(opp, "liked");
        },

        unlikeOpportunity: function likeOpportunity(opp) {
            return this.setOpportunityLikeStatus(opp, "unliked");
        },

        getOpportunityLikes: function getOpportunityLikes(opp) {
            var url = this.Routes.v2_get_opportunity_likes_path(opp._id);
            var deferred = this.$q.defer();
            this.apiFetch(url, null).then(function (resp) {
                if (resp.data.data) {
                    if (typeof resp.data.is_liked === 'boolean') {
                        opp.is_liked = resp.data.is_liked;
                    }
                    if (typeof resp.data.total === 'number') {
                        opp.likes_count = resp.data.total;
                    }
                    deferred.resolve(resp.data.data); //includes the users
                }
            }).catch(function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        },

        updateContactDetails: function updateContactDetails(contact_data) {
            var data = contact_data.details;
            var url = this.Routes.v2_update_contact_details_path(contact_data._id);
            return this.apiUpdate(url, data);
        },

        sendViewOpportunitiesByIds: function sendViewOpportunitiesByIds(ids){
            var url = this.Routes.v2_set_opportunity_viewed_path();
            var data = {status: "viewed"};
            data['ids'] = ids;
            return this.apiCreate(url, data);
        }

    });
}());
